var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0908 40.7274H34.9089V46.5455H29.0908V40.7274ZM29.0908 17.4546H34.9089V34.9092H29.0908V17.4546ZM31.9708 2.90918C15.9126 2.90918 2.90894 15.9419 2.90894 32.0001C2.90894 48.0583 15.9126 61.091 31.9708 61.091C48.058 61.091 61.0908 48.0583 61.0908 32.0001C61.0908 15.9419 48.058 2.90918 31.9708 2.90918ZM31.9998 55.2728C19.1417 55.2728 8.72712 44.8583 8.72712 32.0001C8.72712 19.1419 19.1417 8.72736 31.9998 8.72736C44.858 8.72736 55.2726 19.1419 55.2726 32.0001C55.2726 44.8583 44.858 55.2728 31.9998 55.2728Z",
    fill: "#004B71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.b6f035360f2a664797bc2f8529e8c84c.svg";
export { ForwardRef as ReactComponent };